<div ngDefaultControl [formGroup]="formGroup">
	<div class="zk-flex zk-gap-1">
		<span class="expiration__label">{{
			'SCHEDULE.EXPIRATION' | translate
		}}</span>
		<div
			freud-tooltip
			[tooltipLabel]="'SCHEDULE.EXPIRATION_TOOLTIP' | translate"
		>
			<span class="freud-icon freud-icon-info-circle"></span>
		</div>
	</div>
	<div>
		<freud-select
			ngDefaultControl
			[ngClass]="{
				'expiration__input--error':
					!formGroup.controls.expiration.valid &&
					formGroup.controls.expiration.touched
			}"
			[options]="options"
			formControlName="expiration"
			[disabled]="!isUserPremium"
			[attr.disabled]="!isUserPremium"
			(onChange)="onChange.emit($event)"
			[invalid]="
				!formGroup.controls.expiration.valid &&
				formGroup.controls.expiration.touched
			"
			optionValue="value"
		></freud-select>
		<span
			class="expiration__error"
			*ngIf="
				!formGroup.controls.expiration.valid &&
				formGroup.controls.expiration.touched
			"
			>{{ 'SCHEDULE.EXPIRATION_ERROR' | translate }}</span
		>
	</div>
</div>
